module.exports = __webpack_public_path__ + "static/media/tada1.66918ced.mp3";